/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState ,useCallback } from "react";
import { APIEndpoint } from "../../../utils/axios";
import { Modal } from "../../../common";
import CustomSelect from "../../../common/CustomSelect";
// import searchIcon from '../../../assets/icons/search.svg';
import { useTranslation } from "react-i18next";
import moment from "moment";
import { WithDrawDeposit } from "./withdrawModal";
// import viewIcon from "../../../assets/view.svg";
// import LoadingGIF from '../../../assets/loadingIn.gif';
import {getCultureFromLs} from "../../../utils/commonFunctions";
import { toast, ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';




  const filterData = {
    action: 4,
    collection: '',
    filterOperation: 'or',
    filters: [{ employeeType: 'crew' }],
    limit: 50,
    page: 1,
    searchParam: ''
  };
// const getAllowedMonths = () => {
//   const months = [];
//   const now = moment().startOf("month");

//   for (let i = 0; i < 4; i++) {
//     const m = moment(now).subtract(i, "months");
//     months.push({
//       key:i,
//       label: m.format("MMMM YYYY"),
//       value: m.format("MMMM YYYY"),   
//     });
//   }

//   return months;
// };
export const BankDepositsPage = () => {
  const { ready } = useTranslation();

// const allowedMonths = getAllowedMonths(

// const [selectedMonth, setSelectedMonth] = useState(allowedMonths[0]);

const [filterDate,] = useState(
  moment().startOf("month").toDate()
);
  const [, setLoadingUsers] = useState(false);
  const [, setCrewMembersMaster] = useState([]);
  const [cashDrawerList, setCashDrawerList] = useState([]);
  const [state, setState] = useState({resetDataSource:false,months:[],baseCurrency:getCultureFromLs()?.currency?.code,});
  const [cashDrawer, setCashDrawer] = useState(null);
  const[initialSystemBalance, setInitialSystemBalance] = useState(null);
  const [values, setValues] = useState(null);


  const [, setLoading] = useState(true);



  const fetchCashDrawers = async () => {
    const res = await APIEndpoint.get("cashRegister/cashDrawers");
  
    const list = (res.result || []).map(d => ({
      value: d.id,
      label: d.value
    }));
    setCashDrawerList(list)
    if (list.length === 1) {
      setCashDrawer(list[0].value);
    }
  };


  const fetchCheckStatus = async () => {
    if (!cashDrawer || !filterDate) return;



  };


// const Columns = [
//   { field: 'drawName',headerName: 'Draw Name',tooltipField:'itemCode',flex:1, cellStyle: {
//     whiteSpace: 'nowrap',
//     overflow:'hidden',
//     textOverflow:'ellipsis',
//   },suppressSizeToFit:true, resizable:true, minWidth: 140,width:190 },
//   { field: 'cashier', headerName: 'Cashier',flex:1, suppressSizeToFit:true, resizable:true, minWidth: 135 },
//   { field: 'checkIn', headerName: 'Check-In',flex:1, suppressSizeToFit:true, valueGetter: params => {
//       return params.data ? moment(params.data?.checkIn).tz(getCultureFromLs()?.timezone.name).format('DD-MM-YYYY hh:mm A') : '';
//   },resizable:true, minWidth: 135 },
//   { field: 'checkOut', headerName: 'Check-Out',flex:1, suppressSizeToFit:true,valueGetter: params => {
//       return params.data ? moment(params.data?.checkOut).tz(getCultureFromLs()?.timezone.name).format('DD-MM-YYYY hh:mm A') : '';
//   }, resizable:true, minWidth: 135 },
//   { field: 'openingBalance', headerName:getDynamicHeader('Opening Balance'),flex:1, suppressSizeToFit:true, resizable:true, minWidth: 135 },
//   { field: 'closingBalance', headerName:getDynamicHeader('Closing Balance'),flex:1, suppressSizeToFit:true, resizable:true, minWidth: 135 },



// ];
  useEffect(() => {
    if (!ready) return;

    const init = async () => {
      await fetchCashDrawers();
      setLoading(false);
    };

    init();
   
getEmployeesAll();
  }, [ready]);


  useEffect(() => {
    fetchCheckStatus();
  }, [cashDrawer, filterDate]);
async function fetchEmployees(page=1, perPage=1,searchKey=''){
  filterData.page = page;
  filterData.limit = perPage;
  filterData.searchParam = searchKey;
  try {
    const res=await APIEndpoint.post('employees/process',filterData);
    return res;
  } catch (error) {
    console.error("Failed to fetch employees:", error);
  }
}

const getEmployeesAll = useCallback(async () => {
  setLoadingUsers(true);
  try {
    const initialRes = await fetchEmployees(1, 1);
    const total = initialRes?.count || 0;

    if (total > 0) {
      const fullRes = await fetchEmployees(1, total);

      if (Array.isArray(fullRes?.items) && fullRes.items.length) {
        const formattedEmployees = fullRes.items.map((item, index) => ({
          key: item.employeeId,
          label: `${item.employeeCode} - ${item.name}`,
          value: item.employeeCode,
        }));
        setCrewMembersMaster(formattedEmployees);
      }
    }
  } catch (error) {
    console.error("Failed to fetch employees:", error);
  } finally {
    setLoadingUsers(false);
  }
}, []);


  // const renderActionButton = () => {
  //   if (!cashDrawer) return null;

  //   if (!checkStatus.isCheckedIn) {
  //     return (
  //       <button
  //         className="add-item-button"
  //         onClick={() => setShowCheckModal(true)}
  //       >
  //         Check-In
  //       </button>
  //     );
  //   }

  //   if (checkStatus.isCheckedIn && checkStatus.checkedInByMe) {
  //     return (
  //       <button
  //         className="add-item-button"
  //         onClick={() => setShowCheckModal(true)}
  //       >
  //         Check-Out
  //       </button>
  //     );
  //   }


  //   return (
  //     <span className="info-text">
  //       Cash Drawer is currently in use
  //     </span>
  //   );
  // }; 


  const validateAndTransformValues = (values) => {
    if (!values || !Array.isArray(values)) {
      return null;
    }

    const transformedData = {
      items: [],
      drawValues: [],
      finalValues: []
    };

    values.forEach(item => {
      // Transform withDrawAmount to items
      if (item.withDrawAmount !== undefined && item.withDrawAmount !== null && item.withDrawAmount !== '') {
        transformedData.items.push({
          currencyCode: item.currency,
          amount: parseFloat(item.withDrawAmount) || 0
        });
      }

      // Transform drawValue to drawValues
      if (item.drawValue !== undefined && item.drawValue !== null && item.drawValue !== '') {
        transformedData.drawValues.push({
          currencyCode: item.currency,
          amount: parseFloat(item.drawValue) || 0
        });
      }

      // Transform finalValue to finalValues
      if (item.finalValue !== undefined && item.finalValue !== null && item.finalValue !== '') {
        transformedData.finalValues.push({
          currencyCode: item.currency,
          amount: parseFloat(item.finalValue) || 0,
          remark: item.remarks,
          varianceAcknowledged: item.discrepancy
        });
      }
    });

    return transformedData;
  };


  const handleWithDraw = async () => {
    const transformedData = validateAndTransformValues(values);
    
    if (!transformedData) {
      toast.error("Invalid values provided");
      return;
    }

    const payload= {
      cashDrawerId: cashDrawer,
      items: transformedData.items,
      drawerBalance: transformedData.drawValues,
      confirmedBalance: transformedData.finalValues
    }



    try {
     const res = await APIEndpoint.post(`cashRegister/v2/bankTransfers`, payload);
     toast.success(res.message);
     setState((_) => ({ ..._, showCheckModal: false }));
    } catch (error) {
      toast.error(JSON.parse(error.message)?.data?.message);
    }

    setState((_) => ({ ..._, showCheckModal: false }));
  };


  const onWithdrawClick = async () => {

    const payload = {};

    try {
      
      const res = await APIEndpoint.post(`cashRegister/v2/cashDrawers/${cashDrawer}/initiateBankTransfer`, payload);

    setInitialSystemBalance(res?.systemBalance)
    setState((_) => ({ ..._, showCheckModal: true }))
    } catch (error) {
      toast.error(JSON.parse(error.message)?.data?.message);
    }

   
  }




  return (
    <div className="flexCol width100 ag-theme-alpine-dark cash-reg">

         <div className='flexCol full-flex'>
       <div className='flexCol full-flex'>
            <div className='flexRow alignItemsCenter justifyContentSpaceBetween margBottom6'>
              <div className='flexRow alignItemsCenter'>

                <div className='margLeft6'>
                <CustomSelect
                  options={cashDrawerList}
                  placeHolder="Search Drawer"
                  onChange={(e) => {
                    setCashDrawer(e?.value|| "");
                  }}
                />
                </div>
                  <div className='margLeft6'>
                <CustomSelect
                  options={state.cashDrawerList}
                  placeHolder="Search Location"
                  onChange={(e) => {
                    setCashDrawer(e?.value|| "");
                  }}
                />
                </div>
                   {/* <div className="flexRow justifyContentCenter alignItemsCenter width100 content-tabs">
                     <div className="margLeft margBot10 margTop8 underline">
                       <span><img className="icon-size" alt={t('filters.searchText')} src={searchIcon} /></span>
                       <span>
                         <input
                           className="search"
                           onChange={onSearch}
                           type="search"
                           placeholder={t('filters.searchText')}
                           value={searchKey}
                         />
                       </span>
                     </div>
                   </div> */}
              </div>
               <div className='flexRow justifyContentFlexEnd'>
                  { <button className='add-item-button'
                  onClick={onWithdrawClick}>
                 Withdraw
                </button>}

              </div>
      
            </div>

          

          </div>

         </div>
   

      {state?.showCheckModal && (
        <Modal
          title={"Withdraw Deposit"}
          buttonLabel="Save"
          onClose={() =>    setState((_) => ({ ..._, showCheckModal: false }))}
          onSubmit={ handleWithDraw }
        >
            <WithDrawDeposit
              cashDrawerId={cashDrawer}
              date={filterDate}
              systemBalance={initialSystemBalance}
              onChange={(values) => {
                setValues(values);
              }}
              cashDrawerName={cashDrawerList?.find(item => item.value === cashDrawer)?.label}
            />
          
        </Modal>
      )}

<ToastContainer  position="top-right"  
   toastStyle={{ fontSize: '1rem' }} 
  newestOnTop={true}
  rtl={false}
  pauseOnFocusLoss={false}
  draggable={false}
  pauseOnHover ={false}
  />
    </div>
  );
};
